import { render, staticRenderFns } from "./secondlist.vue?vue&type=template&id=5c8e5235&scoped=true&"
import script from "./secondlist.vue?vue&type=script&lang=js&"
export * from "./secondlist.vue?vue&type=script&lang=js&"
import style0 from "./secondlist.vue?vue&type=style&index=0&id=5c8e5235&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8e5235",
  null
  
)

export default component.exports